import { Tooltip } from "components";
import { fixedDigitsValue } from "helpers/dataHelpers";

export const columns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    sorter: true,
  },
  {
    title: "Price",
    dataIndex: "fiatCentsPrice",
    key: "fiatCentsPrice",
    align: "right" as const,
    sorter: true,
    width: 150,
    render: (value: string) => `${fixedDigitsValue(value, 3)} KWD`,
  },
];

export const mobileColumns = columns.map(column =>
  column.key === "name"
    ? {
        ...column,
        render: (name: string) => (
          <Tooltip title={name} trigger={"click"}>
            {name}
          </Tooltip>
        ),
      }
    : column,
);
